uniform sampler2D u_image;
varying vec2 v_texCoord;
uniform float u_fovy_scale;

vec3 rgb2hsv(vec3 c) {
    vec4 K = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);
    vec4 p = mix(vec4(c.bg, K.wz), vec4(c.gb, K.xy), step(c.b, c.g));
    vec4 q = mix(vec4(p.xyw, c.r), vec4(c.r, p.yzx), step(p.x, c.r));

    float d = q.x - min(q.w, q.y);
    float e = 1.0e-10;
    return vec3(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);
}

vec3 hsv2rgb(vec3 c) {
    vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);
    vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);
    return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);
}

vec3 clampBrightness(vec3 rgb, float min, float max) {
    vec3 hsv = rgb2hsv(rgb);
    hsv.z = clamp(hsv.z, min, max);
    return hsv2rgb(hsv);
}

vec4 pack(float value) {
    float intPart = floor(value);
    float fracPart = fract(value) * 255.0;

    vec4 rgba = vec4(
    mod(floor(intPart / 65536.0), 256.0),
    mod(floor(intPart / 256.0), 256.0),
    mod(intPart, 256.0),
    fracPart
    ) / 255.0;

    return rgba;
}

void main() {
    // Scale and shift the texture coordinates
    vec2 scaledCoord = v_texCoord * u_fovy_scale + (1.0 - u_fovy_scale) * 0.5;

    vec4 texColor = texture2D(u_image, scaledCoord);
    vec3 hsv = rgb2hsv(texColor.rgb);
    float brightness = hsv.z;
    gl_FragColor = pack(brightness);
}
